import React from 'react';
import PropTypes from 'prop-types';

const ShoppingCart = ({ href, badgeCount }) => (
  <a href={href}>
    <span className="n2-shopping-cart">
      <span className="material-icons white-text">shopping_cart</span>
      <span className="n2-badge badge red darken-1">{badgeCount}</span>
    </span>
  </a>
);

ShoppingCart.propTypes = {
  href: PropTypes.string.isRequired,
  badgeCount: PropTypes.number.isRequired,
};

export default ShoppingCart;
